import { Document } from './Document'

class User extends Document {
  constructor (ref, data) {
    super(ref)

    this.birthday = data.birthday?.toDate()
    this.created = data.created.toDate()
    this.displayName = data.displayName
    this.firstName = data.firstName
    this.lastName = data.lastName
    this.firstNameKana = data.firstNameKana
    this.lastNameKana = data.lastNameKana
    this.sex = data.sex
  }

  get fullname () {
    if (!this.firstName || !this.lastName) return undefined
    return this.firstName + ' ' + this.lastName
  }

  get fullnameKana () {
    if (!this.firstNameKana || !this.lastNameKana) return undefined
    return this.firstNameKana + '・' + this.lastNameKana
  }

  get isNameFilled () {
    return this.firstName && this.lastName && this.firstNameKana && this.lastNameKana
  }
}

export { User }
